import dayjs from "dayjs";

export const formatDisplayDate = date => {
  if (!date) return "";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("DD.MM.YYYY") : String(date);
};

export const formatDisplayDateShort = date => {
  if (!date) return "";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("DD.MM") : String(date);
};

export const formatDisplayTime = time => {
  if (!time) return "";
  return String(time).slice(0, 5);
};
